import { createFileRoute, Outlet } from "@tanstack/react-router";

/**
 * /analytics 配下のレイアウト。
 * 一覧（index）と詳細（$reportId）は同階層の兄弟ルートで、この Outlet に差し替わる。
 */
export const Route = createFileRoute("/analytics")({
  component: AnalyticsLayout
});

function AnalyticsLayout() {
  return <Outlet />;
}
